/**
 * `@microsoft/voice-widget-provider-voicelive` — Azure Voice Live adapter.
 *
 * Implements {@link VoiceAgentProvider} for Voice Live over **WebRTC via the
 * Media Gateway** for **both model and agent modes**, and applies session config
 * via `session.update`. Importing this module self-registers the provider so the
 * widget can resolve `provider="voicelive"` without the core importing this
 * package.
 */

import { registerProvider } from "@microsoft/voice-widget-core-client";

import { PROVIDER_NAME, VoiceLiveWebRtcProvider } from "./webrtc-provider.js";

export type { VoiceAgentProvider } from "@microsoft/voice-widget-core-client";
export {
  PROVIDER_NAME,
  VoiceLiveWebRtcProvider,
  type VoiceLiveWebRtcDirectGrant,
} from "./webrtc-provider.js";
export {
  parseVoiceLiveConfig,
  type VoiceLiveConfig,
  type VoiceLiveCommonConfig,
  type VoiceLiveModelConfig,
  type VoiceLiveAgentConfig,
} from "./config.js";
export { buildSessionUpdate, type SessionUpdateEvent } from "./session-config.js";
export { mapRealtimeEvent, type RealtimeServerEvent } from "./realtime-events.js";

// Self-register a factory so each widget owns independent media/session state.
registerProvider(PROVIDER_NAME, () => new VoiceLiveWebRtcProvider());
